import Nav from "../Nav";
import Head from "../Head";

const Bios = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Head title="Nosotras -  Biografías" />
      <Nav titulo="Biografías" link="/nosotras" />
      <section
        id="about_me"
        className="animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="container-fluid overflow-hidden">
          <div className="row marMob">
            <div className="col-12 col-lg-7 text-md-start col-xl-9">
              <h3>Lau Basilico</h3>
              <hr />
            </div>
            <div className="mb-3 col-12 col-lg-5 col-xl-3 text-center">
              <a
                target="_blank"
                href="https://www.instagram.com/lau.basilico/"
                rel="noopener noreferrer"
              >
                <img
                  src="../img/lau_reveadoconrosamosqueta.jpg"
                  className="img-fluid imgBio"
                  alt="Foto de Lau Basilico"
                />
              </a>
            </div>
            <p>
              <p>
                Laura Basílico es fotógrafa, museóloga (ESM) y profesora de
                Antropología por la UNR. Ha realizado la especialización en
                Archivos, Fuentes y Repositorios Digitales (CLACSO). Fue becada
                por el Fondo Nacional de las Artes y el Programa Fomento de la
                Provincia de Santa Fe.
              </p>
              <p>
                Actualmente desarrolla prácticas de revelado artesanal en
                diálogo con paisajes rurales y territorios cercanos, e investiga
                procesos de reveladores y fijadores orgánicos aplicados tanto a
                la imagen fija como a la imagen en movimiento.{" "}
              </p>
              <br />
              <br />
              <a
                href="https://www.espacioanalogico.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span className="violeta">www.espacioanalogico.com.ar</span>
              </a>
            </p>
            <p className="violeta">
              <a
                href="https://www.instagram.com/lau.basilico/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="violeta bi bi-instagram"> </i>
                <span className="violeta">@lau.basilico</span>
              </a>
            </p>
          </div>
          <hr className="d-lg-none" />
          <div className="row marMob mb-5 mt-3">
            <div className="mb-3 col-12 col-lg-5 col-xl-3 text-center">
              <a
                target="_blank"
                href="https://www.pazsecundini.com.ar/"
                rel="noopener noreferrer"
              >
                <img
                  src="../img/paz_reveladoconrosamosqueta.jpg"
                  className="img-fluid imgBio"
                  alt="Foto de Paz secundini"
                />
              </a>
            </div>
            <div className="col-12 col-lg-7 text-md-end col-xl-9">
              <h3>Paz Secundini</h3>
              <hr />
            </div>
            <p className="text-md-end">
              <p>
                Paz Secundini es Licenciada en Bellas Artes (UNR) y Diplomada en
                Estudios Irlandeses (USAL). Su práctica contemporánea explora
                vínculos entre arte y naturaleza a través de la cerámica, la
                instalación, la fotografía analógica y procesos sensibles de
                investigación situada.
              </p>
              <p>
                Fue becada por el Fondo Nacional de las Artes y el Programa
                Fomento de la Provincia de Santa Fe.
              </p>
              <p>
                Su obra fue seleccionada para +Feria, Pinta BA Photo, ArteCo y
                Microferia, y en espacios como Fundación OSDE, Museo Evita
                Palacio Ferreyra, Museo Provincial de Bellas Artes Pedro E.
                Martínez y Casa Nacional del Bicentenario.{" "}
              </p>{" "}
              <p>
                Es artista de Almacén. Arte contemporáneo donde expuso
                individualmente. Participó en residencias en Argentina, Uruguay
                y Chile y fue publicada en medios de Argentina, Estados Unidos,
                Reino Unido, Alemania y Colombia.
              </p>
              <p>
                Actualmente facilita espacios de producción y lleva adelante el
                proyecto Revelar con plantas.
              </p>
              <br />
              <br />
              <a
                href="https://www.pazsecundini.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <span className="violeta">www.pazsecundini.com.ar</span>
              </a>
            </p>
            <p className="text-md-end">
              <a
                href="https://www.instagram.com/jardin.de.invierno/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="violeta bi bi-instagram"> </i>
                <span className="violeta">@jardin.de.invierno</span>
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bios;
